import { useDispatch, useSelector } from 'react-redux'
import styles from './popups.module.css'
import { useState } from 'react'
import { deleteKazoo } from '../../features/kazooEventSlice'
import { useNavigate, useParams } from 'react-router-dom'
import { toastHelper } from '../../util/toastHelper'
import CommonDeleteModal from '../atoms/modal/CommonDeleteModal'
import ButtonCustom from '../atoms/button/ButtonCustom'
import InputCustom from '../atoms/input/InputCustom'

export const DeleteWeddingPopup = ({ popupToggle, clickHandler }) => {
	const dispatch = useDispatch()
	const navigate = useNavigate()
	const { kazooId } = useParams()

	const kazooName = useSelector(
		(state) => state.kazooEvent.dashboardData.kazooName
	)

	const [formData, setFormData] = useState({
		weddingName: '',
	})

	const handleDelete = (e) => {
		e.preventDefault()
		if (kazooName.trim() !== formData.weddingName.trim())
			return toastHelper('Wedding names do not match', 'error')
		dispatch(deleteKazoo(kazooId))
		navigate('/user-dashboard')
	}

	return (
		<CommonDeleteModal
			open={popupToggle}
			handleClose={clickHandler}
			heading="Are you sure you want to delete this wedding?"
			subHeading="This action is permanent and cannot be undone. Please enter the wedding name to proceed."
			footerContent={
				<>
					<ButtonCustom
						disabled={
							formData.weddingName.trim() !== kazooName.trim()
						}
						variant="destructive"
						onClick={handleDelete}
						type="button"
						data-cy="deleteButtonPopup"
					>
						Delete Wedding
					</ButtonCustom>
					<ButtonCustom onClick={clickHandler}>Cancel</ButtonCustom>
				</>
			}
		>
			<form onSubmit={handleDelete}>
				<InputCustom
					placeholder="Wedding Name"
					name="weddingName"
					type="text"
					value={formData.weddingName}
					data={formData}
					autoFocus={true}
					required={true}
					setDataFunction={setFormData}
                    data_cy='weddingName'
				/>
			</form>
		</CommonDeleteModal>
	)
}
